"use client";
import { LogIn } from "lucide-react";
import useAuthModal from "@/features/auth/hooks/use-auth-modal";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import { SidebarMenuButton } from "../ui/sidebar";

const SignInButton = () => {
  const { onOpen: onOpenAuth } = useAuthModal();
  const t = useI18n();
  return (
    <SidebarMenuButton
      onClick={() => onOpenAuth()}
      tooltip={t("auth.signUp")}
      className={cn(
        "flex group-data-[collapsible=icon]:justify-start justify-center bg-brand-primary focus-visible:bg-brand-primary active:bg-brand-primary active:text-white focus:bg-brand-primary text-primary-foreground border-brand-primary hover:bg-brand-primary hover:text-white h-9",
      )}
    >
      <LogIn className="size-4" />
      <span>{t("auth.signUp")}</span>
    </SidebarMenuButton>
  );
};

export default SignInButton;
